import clsx from 'clsx'
import {Link, useLocation} from 'react-router-dom'
import {useAuth} from '../modules/auth'
import {hasPermission, Permissions} from '../modules/auth/permissions'
import './molehr-shell.css'

type ModuleRailItem = {
  label: string
  shortLabel: string
  path: string
  icon: string
  match: (pathname: string) => boolean
  requiresPeopleAccess?: boolean
}

const moduleRailItems: ModuleRailItem[] = [
  {
    label: 'Çalışma Alanım',
    shortLabel: 'Çalışma Alanım',
    path: '/workspace',
    icon: 'bi-grid-1x2-fill',
    match: (pathname) => pathname === '/workspace' || pathname.startsWith('/workspace/'),
  },
  {
    label: 'Çalışan Bilgileri',
    shortLabel: 'Çalışan Bilgileri',
    path: '/employee-information',
    icon: 'bi-people-fill',
    match: (pathname) =>
      pathname === '/employee-information' || pathname.startsWith('/employee-information/'),
    requiresPeopleAccess: true,
  },
  {
    label: 'Mole SELECT',
    shortLabel: 'SELECT',
    path: '/select',
    icon: 'bi-bullseye',
    match: (pathname) => pathname === '/select' || pathname.startsWith('/select/'),
  },
  {
    label: 'Mole TALENT',
    shortLabel: 'TALENT',
    path: '/talent',
    icon: 'bi-gem',
    match: (pathname) => pathname === '/talent' || pathname.startsWith('/talent/'),
  },
  {
    label: 'Mole BALANCE',
    shortLabel: 'BALANCE',
    path: '/cbbee/home',
    icon: 'bi-cash-stack',
    match: (pathname) => pathname === '/cbbee' || pathname.startsWith('/cbbee/'),
  },
]

const MoleHrModuleRail = () => {
  const {auth} = useAuth()
  const {pathname} = useLocation()
  const canViewPeople = hasPermission(auth?.role, Permissions.ViewWorkforceProfileDetails)
  const visibleItems = moduleRailItems.filter(
    (item) => !item.requiresPeopleAccess || canViewPeople
  )
  const beeHiveIsActive = pathname === '/beehive' || pathname.startsWith('/beehive/')
  const organizationTreeIsActive =
    pathname === '/organization-tree' || pathname.startsWith('/organization-tree/')

  return (
    <aside className='molehr-module-rail molesuite-rail-spacer' aria-label='Mole SUITE ana menüsü'>
      <div className='molesuite-rail-surface'>
        <Link className='molehr-rail-brand' to='/workspace' aria-label='Mole SUITE çalışma alanı'>
          <span className='molehr-rail-brand-mark'>M</span>
          <span className='molehr-rail-brand-copy'>
            <strong>Mole SUITE</strong>
            <small>Human Resources Platform</small>
          </span>
        </Link>

        <nav className='molehr-rail-nav molesuite-rail-nav'>
          {visibleItems.map((item) => {
            const isActive = item.match(pathname)
            return (
              <div className='molesuite-rail-item' key={item.path}>
                <Link
                  to={item.path}
                  aria-current={isActive ? 'page' : undefined}
                  className={clsx('molehr-rail-link', {active: isActive})}
                >
                  <span className='molehr-rail-icon' aria-hidden='true'>
                    <i className={clsx('bi', item.icon)}></i>
                  </span>
                  <span className='molehr-rail-label'>{item.label}</span>
                  <span className='molehr-rail-label-mobile'>{item.shortLabel}</span>
                </Link>
              </div>
            )
          })}
        </nav>

        <div className='molehr-rail-footer molesuite-rail-footer'>
          {canViewPeople && (
            <Link
              to='/organization-tree'
              aria-current={organizationTreeIsActive ? 'page' : undefined}
              className={clsx('molehr-rail-link molesuite-organization-tree-link', {
                active: organizationTreeIsActive,
              })}
            >
              <span className='molehr-rail-icon' aria-hidden='true'>
                <i className='bi bi-diagram-3-fill'></i>
              </span>
              <span className='molehr-rail-label'>Organizasyon Ağacı</span>
              <span className='molehr-rail-label-mobile'>Org Ağacı</span>
            </Link>
          )}

          <Link
            to='/beehive'
            aria-current={beeHiveIsActive ? 'page' : undefined}
            className={clsx('molehr-rail-link molesuite-beehive-link', {active: beeHiveIsActive})}
          >
            <span className='molehr-rail-icon' aria-hidden='true'>
              <i className='bi bi-hexagon-fill'></i>
            </span>
            <span className='molehr-rail-label'>BeeHive</span>
            <span className='molehr-rail-label-mobile'>BeeHive</span>
          </Link>

        </div>
      </div>
    </aside>
  )
}

export {MoleHrModuleRail}
